export const zipCodeParser = (zipCode: number) => {
  if (!zipCode) {
    return null;
  }

  let zipCodeString = zipCode.toString();

  const expectedSize = 8;

  if (zipCodeString.length > expectedSize) {
    return null;
  }

  if (zipCodeString.length < expectedSize) {
    const missingDigits = expectedSize - zipCodeString.length;

    let leadingZeros = '';

    for (let i = 0; i < missingDigits; i++) {
      leadingZeros += '0';
    }

    zipCodeString = `${leadingZeros}${zipCodeString}`;
  }

  return `${zipCodeString.slice(0, 5)}-${zipCodeString.slice(5)}`;
};
